import type { Styles } from 'react-native-svg';
import { COLORS } from '@garnish/constants';

import type { ChipState } from '../Chip.types';

export const boxStyles: Record<ChipState, Styles> = {
  default: {
    backgroundColor: COLORS.OPACITY.GREEN_1.ALMOST_TRANSPARENT, //  Green-1 / 4%
    borderColor: COLORS.OPACITY.TRANSPARENT, //                     No Border
  },
  hovered: {
    backgroundColor: COLORS.OPACITY.GREEN_2.LIGHTEST, //            Green-2 / 8%
    borderColor: COLORS.GREEN_2,
  },
  active: {
    backgroundColor: COLORS.OPACITY.GREEN_2.LIGHTEST, //            Green-2 / 8%
    borderColor: COLORS.GREEN_2, //                                 Green-2
  },
  disabled: {
    backgroundColor: COLORS.OPACITY.GREEN_1.LIGHTER, //             Green-1 / 16%
    borderColor: COLORS.OPACITY.TRANSPARENT, //                     No Border
  },
};

export const textStyles: Record<ChipState, Styles> = {
  default: {
    color: COLORS.GREEN_1, //                                       Green-1
  },
  hovered: {
    color: COLORS.NEUTRAL_1, //                                     Neutral-1
  },
  active: {
    color: COLORS.GREEN_1, //                                       Green-1
  },
  disabled: {
    color: COLORS.OPACITY.GREEN_1.DARK, //                          Green-1 / 40%
  },
};
